function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "right-a",
  d: "M4.054 5.5h8.696a1 1 0 0 1 0 2H4.065l3.428 3.161a1.033 1.033 0 0 1 0 1.525 1.23 1.23 0 0 1-1.642 0L.507 7.257a1.012 1.012 0 0 1 0-1.514L5.851.814a1.23 1.23 0 0 1 1.642 0c.218.2.34.473.34.757 0 .284-.122.557-.34.757L4.053 5.5z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "matrix(-1 0 0 1 14 0)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "right-b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#right-a"
})), /*#__PURE__*/React.createElement("g", {
  fill: "currentcolor",
  mask: "url(#right-b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-5-5h24v23H-5z"
})));

const SvgRight = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/right.eec1d138.svg";
export { ForwardRef as ReactComponent };